<template>
  <!-- 店铺管理-账单明细 -->
  <div class="shop-check">
    <div class="ButtonArea">
      <!-- 账单明细 -->
      <div class="Toggle">
        <p
          v-for="(item, index) in ToggleArr"
          :key="index"
          :class="Toggle == item.id ? 'select-p' : ''"
          @click="Toggle = item.id"
        >
          {{ item.name }}
        </p>
      </div>
    </div>
    <!-- 搜索 -->
    <div class="screen">
      <p>时间：</p>
      <!-- 时间选择input -->
      <el-date-picker
        v-model="value1"
        type="daterange"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        unlink-panels
        clearable
        @clear="value1 = null"
      >
      </el-date-picker>
      <p class="user-Id" v-if="Toggle != '3'">结算状态：</p>
      <!-- 结算状态： 下拉选择框 -->
      <div class="size-search" v-if="Toggle != '3'">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <p class="user-Id" v-if="Toggle == '1'">服务标签：</p>
      <!-- 服务标签： 下拉选择框 -->
      <div class="size-search" v-if="Toggle == '1'">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 提现方式 -->
      <p class="user-Id" v-if="Toggle == '3'">提现方式：</p>
      <!-- 提现方式 下拉选择框 -->
      <div class="size-search" v-if="Toggle == '3'">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 提现状态 -->
      <p class="user-Id" v-if="Toggle == '3'">提现状态：</p>
      <!-- 提现状态 下拉选择框 -->
      <div class="size-search" v-if="Toggle == '3'">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 输入订单号 -->
      <div class="OrderNumber">
        <el-input
          v-model="input"
          placeholder="请输入订单号，按enter键搜索"
        ></el-input>
      </div>

      <!-- 搜索重置按钮 -->
      <p class="ser-btn public-style">搜 索</p>
      <p class="heavy-btn public-style">重 置</p>
    </div>
    <!-- 金额统计 -->
    <div class="Statistics" v-if="Toggle == '1'">
      <p>营收额(不含冻结款)：8000</p>
      <p>冻结款：800</p>
    </div>
    <div class="Statistics" v-if="Toggle == '2'">
      <p>总支出金额(不含冻结款)：8000</p>
      <p>冻结款：800</p>
    </div>
    <div class="Statistics" v-if="Toggle == '3'">
      <p>提现总金额：8000</p>
    </div>
    <!-- 表格区 -->
    <div class="tabulation">
      <RevenueTable :tableData="tableData" v-if="Toggle == '1'"></RevenueTable>
      <DisburseTable :tableData="tableData1" v-if="Toggle == '2'"></DisburseTable>
      <withdrawTable :tableData="tableData2" v-if="Toggle == '3'"></withdrawTable>
    </div>
    <!-- 分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
  </div>
</template>

<script>
import paging from "../../../../../components/paging.vue"; // 分页
import RevenueTable from "./components/RevenueTable.vue"; // 营收表
import DisburseTable from "./components/DisburseTable.vue"; // 支出表
import withdrawTable from "./components/withdrawTable.vue"; // 提现表
export default {
  data() {
    return {
      ToggleArr: [
        {
          name: "营收明细",
          id: "1",
        },
        {
          name: "支出明细",
          id: "2",
        },
        {
          name: "提现明细",
          id: "3",
        },
      ], // 账单明细 账单分类
      Toggle: "1", // 账单分类
      value: "", // 状态选择
      value1: null, //时间选择（daterange 需用 null）
      input: "", // 订单号
      options: [], //状态选项
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 8, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页
      tableData: [{}, {}], // 营收表数据
      tableData1: [{}, {}], // 支出表数据
      tableData2: [{}, {}], // 提现表数据
    };
  },
  watch: {},
  components: {
    // 分页
    paging,
    // 营收
    RevenueTable,
    // 支出
    DisburseTable,
    // 提现
    withdrawTable
  },
  created() {},
  methods: {
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      // this.RefreshSysMsgList();
    },
  },
};
</script>

<style scoped lang="less">
// 时间选择框样式（保留左右内边距，避免清空叉号被挤掉/点不中）
/deep/.el-date-editor {
  box-sizing: border-box !important;
  border: 1px solid #409eff ;
  height: 35px;
  width: 240px !important;
  line-height: 35px !important;
  padding: 0 8px !important;
}
/deep/.el-icon-date {
  font-size: 18px !important;
  margin-left: 0 !important;
}
/deep/.el-range__close-icon {
  line-height: 35px;
  width: 25px;
}
.shop-check {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #333333;
  font-weight: 400;
  // 按钮区
  .ButtonArea {
    width: 100%;
    height: 35px;
    display: flex;
    // 服务管理/需求管理
    .Toggle {
      display: flex;
      p {
        width: 110px;
        height: 33px;
        line-height: 33px;
        background: #ffffff;
        border: 1px solid transparent;
        box-shadow: 0px -3px 10px 0px rgba(153, 153, 153, 0.5);
        border-radius: 10px 10px 0px 0px;
        text-align: center;
        margin-right: 10px;
        cursor: pointer;
      }
      .select-p {
        height: 33px;
        line-height: 33px;
        border: 1px solid #409eff ;
        box-shadow: 0px -3px 10px 0px rgba(153, 153, 153, 0.5);
        color: #409eff ;
      }
    }
    // 操作按钮
    .button-box {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      p {
        width: 110px;
        height: 35px;
        line-height: 35px;
        background: #409eff ;
        border-radius: 5px;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        margin-left: 20px;
      }
    }
  }
  // 搜索
  .screen {
    width: 100%;
    height: 35px;
    line-height: 35px;
    display: flex;
    font-family: PingFangSC-Medium;
    position: relative;
    margin-top: 30px;
    .user-Id {
      margin-left: 30px;
    }
    // 重置搜索按钮样式
    .public-style {
      width: 75px;
      height: 35px;
      text-align: center;
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      box-sizing: border-box;
      border: 1px solid #409eff ;
      cursor: pointer;
    }
    // 搜索按钮样式
    .ser-btn {
      background: #409eff ;
      color: #ffffff;
      margin-left: 30px;
      margin-right: 10px;
    }
    // 重置按钮样式
    .heavy-btn {
      background: #ffffff;
      color: #409eff ;
    }
    // 筛选区放input框的div
    .size-search {
      width: 110px;
      height: 30px;
      font-size: 14px;
      /deep/.el-input__inner {
        height: 35px !important;
        border: 1px solid #409eff ;
      }
    }
    // 输入订单号搜索
    .OrderNumber {
      width: 220px;
      height: 30px;
      font-size: 12px;
      margin-left: 40px;
      /deep/.el-input__inner {
        height: 35px !important;
        border: 1px solid #409eff ;
      }
    }
  }
  // 金额统计
  .Statistics {
    width: 100%;
    height: 17px;
    line-height: 17px;
    color: #333333;
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;
    font-size: 14px;
    p {
      margin-left: 40px;
    }
  }
  // 表格
  .tabulation {
    min-height: 200px;
    margin-top: 20px;
  }
  // 分页
  .paging-box {
    width: 100%;
    height: 22px;
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    .paging {
      width: 90%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
